import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowRunStatusFiltersFetchFailedAction = {
	type: 'WORKFLOW_RUN_STATUS_FILTERS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowRunStatusFiltersFetchFailedAction => ({
	type: 'WORKFLOW_RUN_STATUS_FILTERS_FETCH_FAILED',
	payload,
});
